// src/components/Footer.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const whatsappUrl =
    'https://wa.me/34687474802?text=Hola%2C%20quiero%20saber%20m%C3%A1s%20informaci%C3%B3n%20sobre%20ser%20distribuidor%20en%20Reanimeitor.';

  const socialLinks = [
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/reanimeitor/',
      className: 'instagram',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2Zm0 2A3.8 3.8 0 0 0 4 7.8v8.4A3.8 3.8 0 0 0 7.8 20h8.4a3.8 3.8 0 0 0 3.8-3.8V7.8A3.8 3.8 0 0 0 16.2 4H7.8Zm8.7 1.8a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM12 7.3A4.7 4.7 0 1 1 12 16.7 4.7 4.7 0 0 1 12 7.3Zm0 2A2.7 2.7 0 1 0 12 14.7 2.7 2.7 0 0 0 12 9.3Z" />
        </svg>
      )
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@reanimeitorenergydrink',
      className: 'tiktok',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M16.75 2c.28 2.55 1.7 4.08 4.25 4.25v3.1a8.13 8.13 0 0 1-4.18-1.18v6.55c0 4.08-2.7 7.28-6.68 7.28C6.47 22 3.8 19.45 3.8 15.95c0-3.75 3.04-6.36 7.12-6.13v3.28c-1.88-.3-3.46.75-3.46 2.78 0 1.6 1.13 2.75 2.68 2.75 1.82 0 3.02-1.22 3.02-3.62V2h3.59Z" />
        </svg>
      )
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/profile.php?id=61583971288901',
      className: 'facebook',
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14.05 22v-8.25h2.78l.42-3.22h-3.2V8.46c0-.93.26-1.57 1.6-1.57h1.7V4.01A22.6 22.6 0 0 0 14.86 3c-2.47 0-4.16 1.5-4.16 4.27v2.26H7.9v3.22h2.8V22h3.35Z" />
        </svg>
      )
    }
  ];

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) return;

    setStatus('loading');
    setMessage('');

    try {
      const response = await axios.post(
        '/backend/newsletter/suscribir.php',
        { email, nombre: '' },
        {
          headers: { 'Content-Type': 'application/json' },
          timeout: 10000
        }
      );

      if (response.data.success) {
        setStatus('success');
        setMessage(response.data.message || 'Te has suscrito correctamente.');
        setEmail('');

        setTimeout(() => {
          setStatus('idle');
          setMessage('');
        }, 5000);
      } else {
        setStatus('error');
        setMessage(response.data.message || 'Error al suscribir');

        setTimeout(() => {
          setStatus('idle');
          setMessage('');
        }, 5000);
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('error');
      setMessage('Error de conexión con el servidor');

      setTimeout(() => {
        setStatus('idle');
        setMessage('');
      }, 5000);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-energy-bg">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className="footer-container">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-distributor-banner"
          aria-label="Solicitar información para ser distribuidor de Reanimeitor por WhatsApp"
        >
          <img
            src="/Assets/popup.jpeg"
            alt="Banner distribuidor Reanimeitor"
            className="footer-distributor-image"
          />

          <div className="footer-distributor-overlay">
            <div className="footer-distributor-text">
              <small>Haz clic y habla con Reanimeitor por WhatsApp</small>
            </div>

            <div className="footer-distributor-button">
              Contactar
            </div>
          </div>
        </a>

        <div className="newsletter-section">
          <div className="newsletter-copy">
            <span className="newsletter-kicker">REANIMEITOR NEWS</span>
            <h3 className="newsletter-title">Mantente energizado</h3>
            <p>
              Recibe novedades, promociones y noticias de Reanimeitor Energy Drink.
            </p>
          </div>

          <div className="newsletter-action">
            {message && (
              <div className={`newsletter-message ${status}`}>
                {status === 'success' && '✅'}
                {status === 'error' && '⚠️'}
                <span>{message}</span>
              </div>
            )}

            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="tu@email.com"
                className="newsletter-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={status === 'loading' || status === 'success'}
                required
              />

              <button
                type="submit"
                className="newsletter-btn"
                disabled={status === 'loading' || status === 'success'}
              >
                {status === 'loading'
                  ? 'Enviando...'
                  : status === 'success'
                    ? '¡Suscrito!'
                    : 'Suscribirse'}
              </button>
            </form>
          </div>
        </div>

        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="Ir al inicio de Reanimeitor">
              <span className="footer-logo-icon">⚡</span>
              <span className="footer-logo-text">REANIMEITOR</span>
            </Link>

            <p className="footer-description">
              Bebida energética con actitud, sabor y presencia para quienes buscan
              una energía diferente.
            </p>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-whatsapp-cta"
            >
              Ser distribuidor
            </a>

            <div className="footer-social-area">
              <span className="footer-social-title">Síguenos</span>

              <div className="footer-socials" aria-label="Redes sociales de Reanimeitor">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`footer-social-link ${social.className}`}
                    aria-label={`${social.name} de Reanimeitor`}
                    title={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="footer-links">
            <div className="link-group">
              <h4>Productos</h4>
              <a href="/#elige-tu-carga">Todos los productos</a>
            </div>

            <div className="link-group">
              <h4>Empresa</h4>
              <Link to="/about">Sobre nosotros</Link>
              <a href="https://reanimeitor.com/soporte/">Contacto</a>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                Distribuidores
              </a>
            </div>

            <div className="link-group">
              <h4>Cliente</h4>
              <Link to="/login">Iniciar sesión</Link>
              <Link to="/register">Crear cuenta</Link>
              <Link to="/account">Mi cuenta</Link>
            </div>

            <div className="link-group">
              <h4>Legal</h4>
              <Link to="/aviso-legal">Aviso legal</Link>
              <Link to="/politica-privacidad">Privacidad</Link>
              <Link to="/politica-cookies">Cookies</Link>
              <Link to="/politica-tienda">Términos tienda</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="payment-methods">
            <span>Métodos de pago</span>
            <div className="payment-icons">
              <span title="Tarjeta de crédito" aria-label="Tarjeta de crédito">
                💳
              </span>
            </div>
          </div>

          <div className="footer-copyright">
            <div>© 2026 Reanimeitor. Todos los derechos reservados.</div>
            <div className="design-credit">
              Desarrollado con <strong>energía</strong> y actitud.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;